import { useState, useEffect, useRef } from "react";
import { useContentInfo, DEFAULT_CONTENT_INFO } from "../contexts/ContentContext";

function HeroSection() {
  const { contentInfo, loading } = useContentInfo();
  const slides = (!loading && contentInfo?.slides) ? contentInfo.slides : DEFAULT_CONTENT_INFO.slides;
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);

  const startAutoplay = () => {
    intervalRef.current = setInterval(() => {
      setCurrent(i => (i === slides.length - 1 ? 0 : i + 1));
    }, 8000);
  };

  const resetAutoplay = () => {
    clearInterval(intervalRef.current);
    startAutoplay();
  };

  useEffect(() => {
    startAutoplay();
    return () => clearInterval(intervalRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slides.length]);

  const prev = () => {
    setCurrent(i => (i === 0 ? slides.length - 1 : i - 1));
    resetAutoplay();
  };

  const next = () => {
    setCurrent(i => (i === slides.length - 1 ? 0 : i + 1));
    resetAutoplay();
  };

  return (
    <section className="hero-section">
      <div className="hero-slider-track" style={{ transform: `translateX(-${current * 100}%)` }}>
        {slides.map((slide, index) => (
          <div className="hero-slide" key={index}>
            <div className="hero-text">
              <h2 className="brand-tagline">{slide.heroTagline}</h2>
              <h1 className="hero-title">
                {slide.heroTitle}
                <br />
                <span className="big-span">{slide.heroTitleHighlight}</span>
              </h1>
              <h2 className="hero-subtitle">{slide.heroSubtitle}</h2>
              <a href="/products" className="cta-button">Upto {slide.heroCTAButtonText}</a>
            </div>

            <div className="hero-image-wrapper">
              <div className="red-circle">
                <img src="https://i.postimg.cc/d17D7Dfn/Ellipse-2.png" alt="Decorative circle" />
              </div>
              <div className="hero-img-box">
                <img
                  src={slide.heroImageURL || "https://res.cloudinary.com/dzng4fuzh/image/upload/v1776163098/thy1gq688b627ek7bcvy.png"}
                  alt="Happy Customer"
                  className="hero-img"
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="hero-prev" onClick={prev} aria-label="Previous slide">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="currentColor" d="M19 13H6.75L12 18.25l-.66.75l-6.5-6.5l6.5-6.5l.66.75L6.75 12H19z" />
        </svg>
      </button>
      <button className="hero-next" onClick={next} aria-label="Next slide">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="currentColor" d="M4 12h12.25L11 6.75l.66-.75l6.5 6.5l-6.5 6.5l-.66-.75L16.25 13H4z" />
        </svg>
      </button>
    </section>
  );
}

export default HeroSection;
